import React from "react";
import { Form, Col, Grid, Row } from "react-bootstrap";
import icon from "../../img/app_control.png";
import { APP_ENDPOINT, SI_SITE_ENDPOINT } from "../../utils/constants";
import figHome from "../../img/add_app_home.png";
import figSearchApp from "../../img/add_app_search.png";
import figNextApp from "../../img/add_app_next.png";
import figSaveApp from "../../img/add_app_save.png";

type AddAppInstanceFormProps = {
  onSubmit: () => void;
};

function AddAppInstanceForm({ onSubmit }: AddAppInstanceFormProps) {
  return (
    <Grid>
      <div style={{ paddingBottom: "20px" }}>
        <a href={APP_ENDPOINT + "/sync"} id="linkSync">
          Back to Synchronization
        </a>
      </div>
      <Col
        sm={12}
        className="App"
        style={{ background: "#FFFFFF", paddingBottom: "20px" }}
      >
        <div style={{ background: "#FFFFFF" }}>
          <h2>
            <img src={icon} className="top-menu-icon" />
            Google Workspace Directory Auto Synchronization
          </h2>
          <div className="rsi-title">
            <b>Step 1:</b> Go to your home list page
          </div>
          <Col sm={12} className="border border-secondary">
            <Row>
              <p>
                To add an application for Automatic synchronization, Go to{" "}
                <a
                  href={`${SI_SITE_ENDPOINT}/site/2.0/home/edit`}
                  target="_blank"
                >
                  your Home list page.
                </a>
              </p>
              <p>Click 'Add an Application' in this screen.</p>
            </Row>
            <img className="manualFigure" src={figHome} />
          </Col>
          <div className="rsi-title">
            <b>Step 2:</b> Add the application for automatic synchronization
          </div>
          <Col sm={12} className="border border-secondary">
            <Row>
              <p>
                Input "GoogleDirectoryAutoSync" and click the search button.
                Then its icon will be displayed and click it.
              </p>
            </Row>
            <img className="manualFigure" src={figSearchApp} />
            <Row>
              <p>
                To add 'GoogleDirectoryAutoSync' application, Click 'next'
                button.
              </p>
            </Row>
            <img className="manualFigure" src={figNextApp} />
            <Row>
              <p>
                Click 'Save' button. Note that it won't displayed in any home
                although you added it.
              </p>
            </Row>
            <img className="manualFigure" src={figSaveApp} />
          </Col>
          <div className="rsi-title">
            <b>Step 3:</b> Go to the Setting page for automatic synchronization
          </div>
          <Col sm={12} className="border border-secondary">
            <Row>
              <p>
                To register automatic synchronization setting, Click 'Go to
                setting page' button.
              </p>
            </Row>
            <Form horizontal>
              <button
                className="rsi-button is-primary"
                type="button"
                id="sendButton"
                onClick={onSubmit}
              >
                Go to setting page
              </button>
            </Form>
          </Col>
        </div>
      </Col>
    </Grid>
  );
}

export default AddAppInstanceForm;
